import { Input } from "@/src/components/universalInput";
import { FieldOption } from "@/src/data/allTypes";
import { useState } from "react";

export default function FieldOptionForm({
  currentData,
  onChange,
}: {
  currentData?: FieldOption | null | undefined;
  onChange: (newValue: FieldOption | null | undefined) => void;
}) {
  let [data, setData] = useState(currentData || ({} as FieldOption));
  function setNewValue(newValue: FieldOption) {
    setData(newValue);
    onChange(newValue);
  }

  return (
    <div className="grid gap10 c1">
      <Input
        name={"Nom"}
        type={"text"}
        value={data.name}
        onChange={(newValue) => {
          setNewValue({ ...data, name: newValue });
        }}
      />
    </div>
  );
}
